import { BuchungsheldLitElement } from '@adornis/buchungsheld-components/BuchungsheldLitElement.js';
import { ColorDefinitions } from '@adornis/buchungsheld-db/entities/ColorDefinitions.js';
import { GlobalSetting } from '@adornis/buchungsheld-db/entities/global-setting.js';
import { Setting } from '@adornis/buchungsheld-db/entities/settings.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { XSnackbar } from '@adornis/chemistry/elements/components/x-snackbar.js';
import { XDialog } from '@adornis/dialog/x-dialog.js';
import { FormController } from '@adornis/forms/x-form-controller.js';
import { state } from 'lit/decorators.js';
import { BHFormController } from '../../../controller/BHFormController.js';

export class GlobalSettingsAdapter extends BuchungsheldLitElement {
  @state() protected readonly _globalSettings = new RXController(
    this,
    GlobalSetting.getGlobalSetting()(GlobalSetting.allFields),
  );
  @state() protected readonly _formController = new FormController(this, this._globalSettings.observable, {
    success: async setting => {
      try {
        await setting.save();
        await XSnackbar.show(this._translation.translate('global_settings', 'settings_saved'));
      } catch (e) {
        await XDialog.alert(this._translation.translate('global_settings', 'error_saving') + (e as Error).message);
      }
    },
  });

  @state() protected readonly _globalSettingsV2 = new RXController(
    this,
    Setting.getGlobalSettings()({
      ...Setting.allFields,
      colorDefinitions: ColorDefinitions.allFields,
      institutionOverview: 1,
    }).then(settings => {
      console.log('settings: ', settings);
      if (!settings.colorDefinitions) {
        settings.colorDefinitions = new ColorDefinitions({});
        settings.save(); // save empty settings, so that it does not count as dirty
      }
      return settings;
    }),
  );
  @state() protected readonly _formControllerV2 = new BHFormController(this, this._globalSettingsV2.observable, {
    success: async setting => {
      try {
        await setting.save();
        await XSnackbar.show(this._translation.translate('global_settings', 'settings_saved'));
      } catch (e) {
        await XDialog.alert(this._translation.translate('global_settings', 'error_saving') + (e as Error).message);
      }
    },
  });
}
